import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const UsersConfigurationSkeleton = () => {
  return (
    <>
      <Styles.Actions>
        <Skeleton variant="rounded" width={280} height={40} />
        <Skeleton variant="rounded" width={140} height={40} />
        <Skeleton variant="rounded" width={140} height={40} />
      </Styles.Actions>

      <Styles.GroupsContainer>
        {Array.from({ length: 2 }).map((_, groupIndex) => (
          <Styles.GroupContainer key={groupIndex}>
            <Styles.GroupHeader>
              <Styles.GroupInfo>
                <Skeleton variant="text" width={140} height={24} />
                <Skeleton variant="text" width={80} height={20} />
              </Styles.GroupInfo>
              <Skeleton variant="circular" width={24} height={24} />
            </Styles.GroupHeader>

            <Styles.UsersContainer>
              {Array.from({ length: 3 }).map((_, userIndex) => (
                <Styles.UserRow key={userIndex}>
                  <Styles.UserInfoCell>
                    <Skeleton variant="circular" width={40} height={40} />
                    <Styles.NameAndAlias>
                      <Skeleton variant="text" width={140} height={20} />
                      <Skeleton variant="text" width={90} height={18} />
                    </Styles.NameAndAlias>
                  </Styles.UserInfoCell>
                  <Styles.EmailCell>
                    <Skeleton variant="text" width="80%" height={20} />
                  </Styles.EmailCell>
                  <Styles.GroupCell>
                    <Skeleton variant="rounded" width={100} height={24} />
                  </Styles.GroupCell>
                  <Styles.ActionsCell>
                    <Skeleton variant="circular" width={24} height={24} />
                  </Styles.ActionsCell>
                </Styles.UserRow>
              ))}
            </Styles.UsersContainer>
          </Styles.GroupContainer>
        ))}
      </Styles.GroupsContainer>
    </>
  )
}

export default UsersConfigurationSkeleton
